import React from 'react';
import { createRoot } from 'react-dom/client';
import './lib/sentry.ts';
import App from './App.tsx';

// We can remove index.css if we're relying completely on Ant Design,
// or keep it for resetting some global margins if necessary.
import './design/sap-antd-overrides.css';
import './design/components.css';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
